module.exports = __webpack_public_path__ + "static/emitto-app-illustration-5dd7776dc439d846c6634dcae4f95f79.svg";